export enum MainMenuTabs {
	Main = 'main',
	Inventory = 'inventory',
	Shop = 'shop',
	QuestTab = 'questTab',
	FAQ = 'faq',
	Stats = 'stats',
}
